const page = {
  namespaced: true,
  state: {
    // 学历类型
    educationOptions: [
      {
        label: "小学",
        value: "01",
      },
      {
        label: "初中",
        value: "02",
      },
      {
        label: "高中",
        value: "03",
      },
      {
        label: "中专",
        value: "04",
      },
      {
        label: "大专",
        value: "05",
      },
      {
        label: "本科",
        value: "06",
      },
      {
        label: "硕士",
        value: "07",
      },
      {
        label: "博士",
        value: "08",
      },
      {
        label: "其他",
        value: "99",
      },
    ],
    // 参保类型
    insuranceOptions: [
      {
        label: "五险",
        value: "1",
      },
      {
        label: "单工伤",
        value: "2",
      },
      {
        label: "商保",
        value: "3",
      },
    ],
    // 发票状态
    invoiceStatusOptions: [
      {
        //待开票'
        label: "未开票",
        color: "#3B82F6",
        value: 0,
      },
      {
        //待开票'
        label: "待开票",
        color: "#3B82F6",
        value: 1,
      },
      {
        //申请中'
        label: "申请中",
        color: "#3B82F6",
        value: 2,
      },
      {
        label: "已驳回",
        color: "#f35050",
        value: 3,
      },
      {
        label: "已开票",
        color: "#00c7ff",
        value: 4,
      },
      {
        label: "已红冲",
        color: "#ff0000",
        value: 5,
      },
      {
        label: "已取消",
        color: "#d9d9d9",
        value: 6,
      },
      {
        label: "部分冲红",
        color: "#ff9797",
        value: 7,
      },
    ],
    invoiceIsFlushRedOptions: [
      {
        label: "正常",
        color: "#00c7ff",
        value: "0",
      },
      {
        label: "冲红",
        color: "#ff9797",
        value: "1",
      },
    ],
    // 用工类型【flex 易匠通用工， resale 平台承揽】
    orderTypeOptions: [
      {
        label: '自有员工',
        value: 'staff'
      },
      {
        label: "易匠通用工",
        value: "flex",
      },
      {
        label: "合作商户",
        value: "resale",
      },
      {
        label: "业务外包",
        value: "outsource",
      },
      {
        label: "劳务派遣",
        value: "lab",
      },
      {
        label: "在校兼职",
        value: "part_time",
      },
      {
        label: "非全日制用工",
        value: "unfull_time",
      },
      {
        label: "退休返聘",
        value: "rehire",
      },
    ],
    // 订单状态【0待确认，1待支付，2领取中，3已完成、4已取消】
    orderStatusOptions: [
      {
        label: "待确认",
        value: "0",
      },
      {
        label: "待支付",
        value: "1",
      },
      {
        label: "领取中",
        value: "2",
      },
      {
        label: "已完成",
        value: "3",
      },
      {
        label: "已取消",
        value: "4",
      },
    ],
    payStatusOptions: [
      {
        label: "已支付",
        value: "1",
      },
      {
        label: "未支付",
        value: "2",
      },
    ],
    // 户口类型；1：农村户口、2：城镇户口
    residenceTypeOptions: [
      {
        label: "农村户口",
        value: 1,
      },
      {
        label: "城镇户口",
        value: 2,
      },
    ],
    // 婚姻状态；1：已婚、2：未婚、3：离异、4：丧偶
    maritalStatusOptions: [
      {
        label: "已婚",
        value: 1,
      },
      {
        label: "未婚",
        value: 2,
      },
      {
        label: "离异",
        value: 3,
      },
      {
        label: "丧偶",
        value: 4,
      },
    ],
    // 政治面貌code（1 => '群众', 2 => '共青团员', 3 => '中共预备党员', 4 => '中共党员', 5 => '其他党派人士'）
    politicalStatusOptions: [
      {
        label: "群众",
        value: 1,
      },
      {
        label: "共青团员",
        value: 2,
      },
      {
        label: "中共预备党员",
        value: 3,
      },
      {
        label: "中共党员",
        value: 4,
      },
      {
        label: "其他党派人士",
        value: "5",
      },
    ],
    messageStatistics: {
      recharge_count: 0,
      invoice_count: 0,
      reward_count: 0,
      total_count: 0,
    },
    workTypeOptions: [],
    departmentOptions: [],
  },
  mutations: {
    SET_WORK_TYPE_OPTIONS(state, options) {
      state.workTypeOptions = options;
    },
    SET_DEPARTMENT_OPTIONS(state, options) {
      console.log("🔴 options", options);
      state.departmentOptions = options;
    },
    SET_MESSAGE_STATISTICS(state, statistics) {
      state.messageStatistics = statistics;
      state.messageStatistics.total_count =
        statistics.recharge_count +
        statistics.message_count +
        statistics.reward_count;
    },
  },
  actions: {
    async fetchWorkTypeOptions({ commit }) {
      try {
        const { default: Api } = await import("@/api");
        const res = await Api.getJobTypeList({});
        const list = res.data.list || [];

        const clearChildren = (arr) => {
          if (!Array.isArray(arr)) return arr;
          return arr
            .map((item) => {
              if (item.children && Array.isArray(item.children)) {
                const cleanedChildren = clearChildren(item.children);
                if (cleanedChildren.length === 0) {
                  const { children, ...rest } = item;
                  return rest;
                }
                return { ...item, children: cleanedChildren };
              }
              return item;
            })
            .filter((item) => {
              return !(
                item.children &&
                Array.isArray(item.children) &&
                item.children.length === 0
              );
            });
        };

        commit("SET_WORK_TYPE_OPTIONS", clearChildren(list));
        return clearChildren(list);
      } catch (err) {
        console.error("加载岗位选项失败:", err);
        commit("SET_WORK_TYPE_OPTIONS", []);
        return [];
      }
    },
    async fetchDepartmentOptions({ commit }) {
      try {
        const { default: Api } = await import("@/api");
        const res = await Api.scheduleDepartmentList({});
        const list = res.data.tree || [];
        const clearChildren = (arr) => {
          if (!Array.isArray(arr)) return arr;
          return arr
            .map((item) => {
              if (item.children && Array.isArray(item.children)) {
                const cleanedChildren = clearChildren(item.children);
                if (cleanedChildren.length === 0) {
                  const { children, ...rest } = item;
                  return rest;
                }
                return { ...item, children: cleanedChildren };
              }
              return item;
            })
            .filter((item) => {
              return !(
                item.children &&
                Array.isArray(item.children) &&
                item.children.length === 0
              );
            });
        };

        commit("SET_DEPARTMENT_OPTIONS", clearChildren(list));
        return clearChildren(list);
      } catch (err) {
        console.error("加载部门选项失败:", err);
        commit("SET_DEPARTMENT_OPTIONS", []);
        return [];
      }
    },
    async getMessageStatistics({ commit }) {
      try {
        const { default: Api } = await import("@/api");
        const res = await Api.getStatistics({});
        commit("SET_MESSAGE_STATISTICS", res.data || {});
        return res.data || {};
      } catch (err) {
        console.error("获取消息统计失败:", err);
        commit("SET_MESSAGE_STATISTICS", {});
        return {};
      }
    },
  },
};

export default page;
